import { Icon } from '@/ui';

import type { FC } from 'react';

import Card from '@/components/Profile/Card';

interface MomentsCalendarProps {
  calendarSettingsUrl?: string;
}

// MEN-5418: coaches on the Moments calendar set availability and connect their
// Google account in Moments, never in Cal.com.
const MomentsCalendar: FC<MomentsCalendarProps> = ({ calendarSettingsUrl }) => (
  <Card icon="calendar_month" title="Coaching hours availability">
    {!!calendarSettingsUrl && (
      <a
        className="button-label flex items-center gap-2 text-sage-600"
        href={calendarSettingsUrl}
        rel="noreferrer"
        target="_blank"
      >
        View and edit
        <Icon>open_in_new</Icon>
      </a>
    )}
  </Card>
);

export default MomentsCalendar;
